import { E_ROUTE_DEVELOPER_TOOL_COREUTILITY } from './route.types';
export const coreUtility = [
    {
        name: 'core-utility',
        path: '/developerTool/coreUtility',
        redirect: {
            name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY,
        },
        component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/CoreUtility/CoreUtility.vue'),
        children: [
            // 账号信息查询
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY,
                path: 'accountInfo',
                redirect: {
                    name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY_USER,
                },
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/account-info/AccountInfo/AccountInfo.vue'),
                children: [
                    {
                        name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY_USER,
                        path: 'user',
                        component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/account-info/User/User.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.DeveloperTool',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.coreUtility',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.accountInfo',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'coreUtility.account.user',
                                    active: true,
                                }
                            ],
                            permission: 'AccountInformationQuery',
                        },
                    },
                    {
                        name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY_COMPANY,
                        path: 'company',
                        component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/account-info/Company/Company.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.DeveloperTool',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.coreUtility',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.accountInfo',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'coreUtility.account.company',
                                    active: true,
                                }
                            ],
                            permission: 'AccountInformationQuery',
                        },
                    }
                ],
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT,
                path: 'cache',
                redirect: {
                    name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT_DEFAULT_SEARCH,
                },
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/cache/Cache/Cache.vue'),
                children: [
                    {
                        name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT_DEFAULT_SEARCH,
                        path: 'default-search',
                        component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/cache/DefaultSearch/DefaultSearch.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.DeveloperTool',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.coreUtility',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.cache',
                                    to: { name: 'cache' },
                                },
                                {
                                    text: 'coreUtility.cache.defaults',
                                    active: true,
                                }
                            ],
                            permission: 'CoreUtilityCacheManagement',
                        },
                    },
                    {
                        name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT_CUSTOM_SEARCH,
                        path: 'custom-search',
                        component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/cache/CustomSearch/CustomSearch.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.DeveloperTool',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.coreUtility',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.cache',
                                    to: { name: 'cache' },
                                },
                                {
                                    text: 'coreUtility.cache.custom',
                                    active: true,
                                }
                            ],
                            permission: 'CoreUtilityCacheManagement',
                        },
                    },
                    // CACHE MANAGEMENT:
                    {
                        name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT_MANAGE_SEARCH,
                        path: 'manage-search',
                        component: () => import('@/views/coreUtility/cache/Management/Management.vue'),
                        props: true,
                        meta: {
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.DeveloperTool',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.coreUtility',
                                    to: { name: 'account-info' },
                                },
                                {
                                    text: 'backoffice.nav.cache',
                                    to: { name: 'cache' },
                                },
                                {
                                    text: 'coreUtility.cache.manage',
                                    active: true,
                                }
                            ],
                            permission: 'CoreUtilityCacheManagement',
                        },
                    }
                ],
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.COREUTILITY_LIMITATION,
                path: 'limitation',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/Limitation/Limitation.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.limitationRule',
                            active: true,
                        }
                    ],
                    permission: 'Limitation',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.GATEWAY_PERMISSIONS,
                path: 'gateway',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/Gateway/Gateway.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.gateway',
                            active: true,
                        }
                    ],
                    permission: 'GatewayPermissions',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.EMAIL_ALERT_TEST,
                path: 'alert-test',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/AlertTest/AlertTest.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.alert',
                            active: true,
                        }
                    ],
                    permission: 'EmailAlertTest',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.EMAIL_ALERT_DEBUGGER,
                path: 'alert-debugger',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/AlertDebugger/AlertDebugger.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.alertDebugger',
                            active: true,
                        }
                    ],
                    permission: 'EmailAlertDebugger',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.POSTMAN,
                path: 'postman',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/Postman/Postman.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.postman',
                            active: true,
                        }
                    ],
                    permission: 'postman',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CacheManagementTFFI,
                path: 'cache-tffi',
                component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/CacheManagementTFFI/CacheManagementTFFI.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.cacheManageTFFI',
                            active: true,
                        }
                    ],
                    permission: 'CacheManagementTFFI',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CONFIG_LIST,
                path: 'config-list',
                component: () => import(/* '@/views/coreUtility/ConfigList/ConfigList.vue' */ '@/configList/ConfigListIndex/ConfigListIndex.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.configList',
                            active: true,
                        }
                    ],
                    permission: 'ConfigList',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.EMAIL_CONCURRENCY_TEST,
                path: 'email-concurrency-test',
                component: () => import(/* '@/views/coreUtility/ConcurrencyTest/ConcurrencyTest.vue' */ '@/views/coreUtility/ConcurrencyTest/ConcurrencyTest.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.coreUtility',
                            to: { name: 'account-info' },
                        },
                        {
                            text: 'backoffice.nav.concurrencyTest',
                            active: true,
                        }
                    ],
                    permission: 'EmailConcurrencyTest',
                },
            },
            {
                name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.OPERATION_ADD_TRIAL,
                path: 'operation-add-trial',
                component: () => import(/* '@/views/coreUtility/operationAddTrial/operationAddTrial.vue' */ '@/views/coreUtility/operationAddTrial/operationAddTrial.vue'),
                props: true,
                meta: {
                    permission: 'OperationDataUpdate',
                },
                children: [
                    {
                        name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.OPERATION_ADD,
                        path: 'add',
                        component: () => import(/* webpackChunkName: "@/views/coreUtility/operationAddTrial/operation.vue" */ '@/views/coreUtility/operationAddTrial/operation.vue'),
                        props: true,
                        meta: {
                            permission: 'PostBatchTrial',
                        },
                    },
                    {
                        name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.OPERATION_TRIAL,
                        path: 'trial',
                        component: () => import(/* webpackChunkName: "core_utility" */ '@/views/coreUtility/operationAddTrial/trial.vue'),
                        props: true,
                        meta: {
                            permission: 'PostAccountJobRoleComplement',
                        },
                    }
                ],
            }
        ],
    }
];
/**
 * coreUtility 页面级子菜单
 * 注意这里的顺序需要和菜单顺序保持一致
 */
export const coreUtilityRoutePermissionTable = [
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY, permission: 'AccountInformationQuery' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY_USER, permission: 'AccountInformationQuery' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.ACCOUNT_INFORMATION_QUERY_COMPANY, permission: 'AccountInformationQuery' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT_DEFAULT_SEARCH, permission: 'CoreUtilityCacheManagement' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT_CUSTOM_SEARCH, permission: 'CoreUtilityCacheManagement' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CACHE_MANAGEMENT, permission: 'CoreUtilityCacheManagement' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.COREUTILITY_LIMITATION, permission: 'Limitation' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.GATEWAY_PERMISSIONS, permission: 'GatewayPermissions' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.EMAIL_ALERT_TEST, permission: 'EmailAlertTest' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.EMAIL_ALERT_DEBUGGER, permission: 'EmailAlertDebugger' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.POSTMAN, permission: 'postman' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CacheManagementTFFI, permission: 'CacheManagementTFFI' },
    { name: E_ROUTE_DEVELOPER_TOOL_COREUTILITY.CONFIG_LIST, permission: 'ConfigList' }
];
